export const OUTCOME_EVENTS = ['link_sent', 'click', 'signup', 'order'] as const;

export type OutcomeEvent = (typeof OUTCOME_EVENTS)[number];

export function outcomeBadges(events: readonly string[]): OutcomeEvent[] {
  const have = new Set(events);
  return OUTCOME_EVENTS.filter((event) => have.has(event));
}
